import $ from "jquery";
import uly from "ulysses/base";
import ko from "knockout";
import posCalc from "jquery-libs/position-calculator";
import "./pubsub";

ko.bindingHandlers.panel = {
    init: function(elt, va, bindings, model, context) {
        var column = ko.unwrap(bindings().column);

        var settings = ko.unwrap(va());

        var size = ko.unwrap(settings.size) || 3;
        var compact = ko.unwrap(bindings().compact);

        var classes = compact ? "" : " panel-wrapper";

        if (!settings)
            return false;

        if (settings.__ko_mapping__)
            delete(settings.__ko_mapping__);

        var widget_model = {
            "settings":ko.observable(settings),
            "settings_menu":ko.observableArray([{
                "caption":_("panel_caption_delete", "Delete"),
                "icon":"fa-trash",
                "permission": "editpage",
                "action":function(e){
                    var component_type = compact ? "sidebar" : "page";
                    bindings().column.remove(ko.dataFor(elt));
                    uly.publish(component_type + ".savesettings");
                    return false;
                },
                "colour":"danger"
            }]),
            "title": ko.observable(null),
            "actions_menu":ko.observableArray([]),
            "panel_class":ko.observable("box box-primary"),
            "show_footer":ko.observable(false),
            "show_header":ko.observable(true),
            "tooltip":ko.observable(null),
            "icon":ko.observable(null),
            "menu_icon":ko.observable(null),
            "compact": compact,
            "template":ko.unwrap(settings.type) + (compact ? "-compact":"") + "-tmpl",
            "widget_id": "wg_"+ko.unwrap(context.$parentContext.$index)+"_"+ko.unwrap(context.$index)
        };

        widget_model.allowed_settings_menu = ko.pureComputed(()=>{
            var permissions = ko.unwrap(uly.page.userprofile.global_permissions);
            var is_all = permissions.indexOf("*") >= 0;
            return widget_model.settings_menu().filter((action)=> {
                return is_all || !action.permission || permissions.indexOf(action.permission) >= 0;
            })
        });

        //need to update the previous settings when replacing from widget
        widget_model.settings.subscribe(function(new_settings) {
            Object.assign(settings, new_settings);
        });

        var $tmpl = $("#"+widget_model.template),
            $element = $(elt);

        if ($tmpl.length <= 0){
            widget_model.template = "bad-widget-tmpl";
            $element.removeClass("loader").find(".box-body").removeClass("loader");
            widget_model.icon("fa-ban");
        }

        var childContext = context.createChildContext(widget_model);
        ko.applyBindingsToDescendants(childContext, elt);

        var master = ko.unwrap(settings.master);
        if (master) {
            size = 13;
        }

        $element.addClass(classes);
        uly.subscribe("widget.active", function(topic, widget) {
            if (!$(elt).has(widget).length)
                return false;
            uly.publish("panel.active", elt);
            $element.removeClass("loader").find(".box-body").removeClass("loader");
        }, elt);

        $.equery();

        return { controlsDescendantBindings: true };
    }
};
ko.virtualElements.allowedBindings.panel = true;

/*
  Fix Bootstrap Dropdown position
 */
$(document).ready(function() {
    $(document).on("shown.bs.dropdown.position-calculator", function(event, data) {
       var $item = $('.dropdown-menu.auto-pos', event.target);
       var target = event.relatedTarget;
       if (!$item.length) {
           return;
       }
       // reset position
       $item.css({top:0, left:0});

       // calculate new position
       var calculator = new posCalc({
         item    : $item,
         target  : target,
         itemAt  : "top left",
         itemOffset: { y:3, x:0, mirror:true },
         targetAt: "bottom left",
         flip    : "both"
       });
       var posResult = calculator.calculate();

       // set new position
       $item.css({
         top: posResult.moveBy.y + "px",
         left: posResult.moveBy.x + "px"
       });
     });
 });
